import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useGetCurrentUser } from '@wecasa/auth/src/authentication-context';

import { useModalObject } from '@wecasa/common/src/hooks/use-modal';
import type { UniverseReference } from '@wecasa/common/src/types/commons';

import { getBasketMode } from '@wecasa/customer/src/ducks/basket';
import { getUniverseRef } from '@wecasa/customer/src/ducks/basket-selectors';

import { trackMembershipEvent } from '../tracking';

const useMembershipPaywall = () => {
  const location = useLocation();
  const user = useGetCurrentUser();
  const universeReference: UniverseReference = useSelector(getUniverseRef);
  const mode = useSelector(getBasketMode);
  const { isOpen: isMembershipPaywallVisible, open: openPaywall, close: closeMembershipPaywall } = useModalObject();

  const openMembershipPaywall = useCallback(() => {
    openPaywall();

    trackMembershipEvent({
      eventType: 'PaywallView',
      user,
      path: location.pathname,
      universeReference,
      mode,
    });
  }, [location.pathname, openPaywall, universeReference, user, mode]);

  return {
    isMembershipPaywallVisible,
    openMembershipPaywall,
    closeMembershipPaywall,
  };
};

export default useMembershipPaywall;
